import * as signalR from "@microsoft/signalr"
import appconfig from "./AppConfig";
//const URL = process.env.HUB_ADDRESS ?? "https://localhost:5001/hub" //or whatever your backend port is
const URL = process.env.HUB_ADDRESS ?? (appconfig.apiurl +"hub") //or whatever your backend port is

class Connector {
    constructor() {
        this.connection = new signalR.HubConnectionBuilder()
            .withUrl(URL, { withCredentials: false, skipNegotiation: true, transport: signalR.HttpTransportType.WebSockets })
            .withAutomaticReconnect()
            .build()

        this.isSilentSignalRError = (err) => {
            const message = (err && err.message ? err.message : err || "").toString().toLowerCase();
            return message.includes("websocket failed to connect") || message.includes("proxy blocking websockets") || message.includes("connection could not be found on the server");
        };

        this.connection.start().catch(err => {
            if (!this.isSilentSignalRError(err)) {
                console.error(err);
            }
        })

        this.events = (onMessageReceived, onSomeOtherServerEventReceived) => {
            this.connection.on("messageReceived", (username, message) => {
                onMessageReceived(username, message)
            })
        }

    }
    newMessage = messages => {
        this.connection
            .send("newMessage", "foo", messages)
            .then(x => console.log("sent"))
            .catch(err => {
                if (!this.isSilentSignalRError(err)) {
                    console.error(err);
                }
            })
    }
    static getInstance() {
        if (!Connector.instance) Connector.instance = new Connector()
        return Connector.instance
    }
}
export default Connector.getInstance